import React, { useEffect } from "react";
import Star from "./Star";
import { RatingContainer } from "./styled";

const Rating = ({ value, isEditable, onChange = () => {} }) => {
  const [rating, setRating] = React.useState(+value || 0);
  const [hoverId, setHoverId] = React.useState(0);

  const onStarClick = (starId) => {
    if (isEditable) {
      setRating(starId);
      onChange(starId);
    }
  };

  const onStarHover = (starId) => isEditable && setHoverId(starId);

  useEffect(() => {
    setRating(+value);
  }, [value]);

  return (
    <RatingContainer isEditable={isEditable}>
      {[1, 2, 3, 4, 5].map((starId, i) => (
        <Star key={i} rating={rating} starId={starId} hoverId={hoverId} onHover={onStarHover} onClick={onStarClick} />
      ))}
    </RatingContainer>
  );
};

export default Rating;
